import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import i18n from "shared/i18n";
import { Translation } from 'react-i18next';

import { patchSocialLink } from 'redux/social/actions';
import CommonPopup from 'components/common/CommonPopup';
import ButtonSwitcher from 'components/elements/buttons/ButtonSwitcher';
import './SocialLinkIsButton.css';

class SocialLinkIsButton extends Component {
  static propTypes = {
    patchSocialLink: PropTypes.func.isRequired,
    itemId: PropTypes.number.isRequired,
    isButton: PropTypes.bool,
  };

  static defaultProps = {
    isButton: null,
  };

  state = {
    firstChange:  null,
    currentIsButton: null,
  };

  componentDidMount() {
    this.setState({ currentIsButton: this.props.isButton });
  }

  componentDidUpdate(prevProps, prevState) {
    const { itemId, patchSocialLink } = this.props;
    const { currentIsButton, firstChange } = this.state;

    if (
      !!firstChange &&
      prevState.currentIsButton !== this.state.currentIsButton
    ) {
      patchSocialLink(itemId, { is_button: currentIsButton });
    }
  }

  toggleButtonMode = (currentIsButton) => {
    this.setState({
      firstChange: true,
      currentIsButton,
    });
  }

  render() {
    const { isButton } = this.props;
    const buttonsList = [
      {
       buttonName: i18n.t("Button"),
       executeFunc: () => {this.toggleButtonMode(true)},
       checked: isButton,
      },
      {
        buttonName: i18n.t("Icon"),
        executeFunc: () => {this.toggleButtonMode(false)},
        checked: !isButton,
      },
    ];
    
    return (
      <Translation>
        {(t) => (
          <div className="social-link-is-button__component">
            <nobr>{t("Show as")}</nobr>
            <CommonPopup
              questionIcon
              type='info'
            >
              {t("You can show any social link as icon or as button. " +
                "For example, your Instagram link could be shown as " +
                "button whereas your email could be shown as icon. " +
                "Customize as your wish, no limits!")}
            </CommonPopup>
            <ButtonSwitcher
              buttonsList={buttonsList}
            />
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {}
);

export default connect(
  mapStateToProps,
  {
    patchSocialLink,
  },
)(SocialLinkIsButton);
